import React from 'react'
import { Link, navigate } from 'gatsby'
import PropTypes from 'prop-types'
import Icon from './Icon'
import ModalOverlay from './ModalOverlay'
import { useQueryParams, StringParam, NumberParam } from 'use-query-params'
import { useSearchLocations, useGetGeoLocation } from 'src/core'
import { useAtom } from 'jotai'
import { placeNameAtom } from '../atoms'
const Search = ({ storeType }) => {
  const postCodeRef = React.useRef([])
  const {
    inputText,
    setInputText,
    postcodes,
    places,
    typing,
  } = useSearchLocations()

  const isMorrisonsDaily = storeType === 'MorrisonsDaily'

  const { loading, error: postcodesError, result: postcodesResult } = postcodes
  const { error: placesError, result: placesResult } = places

  const [showResults, setShowResults] = React.useState(false)

  const [filter, setQuery] = useQueryParams({
    postcode: StringParam,
    place: StringParam,
    lat: NumberParam,
    lon: NumberParam,
    storeType: StringParam,
  })
  const [, setPlaceName] = useAtom(placeNameAtom)

  const storeTypeDefault = 'Morrisons_GasStation_Franchise_MorrisonsDaily'

  // const storeTypeDefault = isMorrisonsDaily
  // ? 'GasStation_Franchise_MorrisonsDaily'
  //  : storeType

  const {
    getGeolocation,
    longitude,
    latitude,
    geoError,
    fetchingPosition,
  } = useGetGeoLocation(false)

  React.useEffect(() => {
    if (!!longitude && !!latitude) {
      navigate(
        `/all/?lat=${latitude}&lon=${longitude}&storeType=${storeTypeDefault}`
      )
    }
  }, [setQuery, longitude, latitude, storeTypeDefault])

  function handleSearch() {
    if (inputText?.length < 3) return
    const noSpaceString = inputText?.replace(/\s/g, '')
    const upperPostcode = noSpaceString.toUpperCase()
    const isPostcode = /\d/.test(noSpaceString)

    if (upperPostcode.startsWith('JE')) {
      let latitude = 49.2138
      let longitude = -2.1311
      navigate(
        `/all/?lat=${latitude}&lon=${longitude}&storeType=${storeTypeDefault}`
      )
    } else if (upperPostcode.startsWith('GY')) {
      let latitude = 49.4657
      let longitude = -2.5353
      navigate(
        `/all/?lat=${latitude}&lon=${longitude}&storeType=${storeTypeDefault}`
      )
    } else if (isPostcode) {
      const formattedPostcode = noSpaceString?.toUpperCase()
      navigate(
        `/all/?postcode=${formattedPostcode}&storeType=${storeTypeDefault}`
      )
    } else {
      navigate(`/all/?place=${inputText}&storeType=${storeTypeDefault}`)
    }

    setShowResults(false)
  }

  function handleKeyDown(event) {
    if (event.keyCode === 13) {
      handleSearch()
    }
    if (event.keyCode === 27) {
      setInputText('')
    }
    if (event.keyCode === 40) {
      postCodeRef?.current?.[0]?.focus()
    }
  }

  function handlePostcodeKeydown(event, i) {
    if (event.keyCode === 38) {
      //up
      if (i === 0) {
        postCodeRef?.current?.[
          postcodesResult?.data?.result?.length - 1
        ]?.focus()
      }
      postCodeRef?.current?.[i - 1]?.focus()
    }
    if (event.keyCode === 40) {
      // down
      if (i === postcodesResult?.data?.result?.length - 1) {
        postCodeRef?.current?.[0]?.focus()
      }
      postCodeRef?.current?.[i + 1]?.focus()
    }
  }

  function handleClose() {
    setShowResults(false)
  }

  let dataLayer

  if (typeof window !== `undefined`) {
    dataLayer = window.dataLayer
  }

  function clickCurrentLocation() {
    if (dataLayer && dataLayer.push) {
      dataLayer.push({
        event: 'currentLocationSearch',
      })
    }
  }

  function renderSearchResults() {
    let component
    switch (true) {
      case (postcodesError || placesError) && true:
        component = (
          <div className="p-0 mb-5 text-lg">
            Search is not available at this time. Please try again later.
          </div>
        )
        break
      case (postcodesResult?.data?.status === 200 &&
        !postcodesResult?.data?.result?.length) ||
        (placesResult?.data?.status === 200 &&
          !placesResult?.data?.result?.length):
        component = (
          <div className="p-4 text-lg font-semibold">
            Sorry, we have no matching locations
          </div>
        )
        break
      case !!postcodesResult?.data?.result?.length ||
        !!placesResult?.data?.result?.length:
        component = (
          <section className="flex flex-col p-0 px-4 pt-4 mb-5 text-base font-semibold lg:text-lg">
            {postcodesResult?.data?.result?.length > 0 ? (
              <h2 className="mt-3 mb-2 text-sm font-semibold uppercase lg:text-md text-body-light">
                Postcodes
              </h2>
            ) : null}
            {postcodesResult?.data?.result?.map((postcode, i) => {
              if (postcode.startsWith('JE')) {
                let latitude = 49.2138
                let longitude = -2.1311
                return (
                  <Link
                    key={i}
                    className="px-2 py-2 m-0 -mx-2 border border-t-0 border-r-0 border-l-0 border-body-lightest hover:bg-body-lightest focus:bg-body-lightest last:border-b-0"
                    ref={el => (postCodeRef.current[i] = el)}
                    onKeyDown={event => handlePostcodeKeydown(event, i)}
                    onClick={() => {
                      setShowResults(false)
                    }}
                    to={`/all/?lat=${latitude}&lon=${longitude}&storeType=${storeTypeDefault}`}
                  >
                    {postcode}
                  </Link>
                )
              } else if (postcode.startsWith('GY')) {
                let latitude = 49.4657
                let longitude = -2.5353
                return (
                  <Link
                    key={i}
                    className="px-2 py-2 m-0 -mx-2 border border-t-0 border-r-0 border-l-0 border-body-lightest hover:bg-body-lightest focus:bg-body-lightest last:border-b-0"
                    ref={el => (postCodeRef.current[i] = el)}
                    onKeyDown={event => handlePostcodeKeydown(event, i)}
                    onClick={() => {
                      setShowResults(false)
                    }}
                    to={`/all/?lat=${latitude}&lon=${longitude}&storeType=${storeTypeDefault}`}
                  >
                    {postcode}
                  </Link>
                )
              } else {
                const formattedPostcode = postcode?.replace(/\s/g, '')
                return (
                  <Link
                    key={i}
                    className="px-2 py-2 m-0 -mx-2 border border-t-0 border-r-0 border-l-0 border-body-lightest hover:bg-body-lightest focus:bg-body-lightest last:border-b-0"
                    ref={el => (postCodeRef.current[i] = el)}
                    onKeyDown={event => handlePostcodeKeydown(event, i)}
                    onClick={() => {
                      setShowResults(false)
                    }}
                    to={`/all/?postcode=${formattedPostcode}&storeType=${storeTypeDefault}`}
                  >
                    {postcode}
                  </Link>
                )
              }
            })}

            {placesResult?.data?.result?.length > 0 ? (
              <h2 className="mt-3 mb-2 text-sm font-semibold uppercase lg:text-md text-body-light">
                Places
              </h2>
            ) : null}

            {placesResult?.data?.result?.map((place, i) => {
              return (
                <Link
                  key={i}
                  className="px-2 py-2 m-0 -mx-2 border border-t-0 border-r-0 border-l-0 border-body-lightest hover:bg-body-lightest focus:bg-body-lightest last:border-b-0"
                  ref={el => (postCodeRef.current[i] = el)}
                  onKeyDown={event => handlePostcodeKeydown(event, i)}
                  onClick={() => {
                    setShowResults(false)
                    const pName = `${place?.name_1},
                    ${
                      place?.county_unitary ? `${place.county_unitary}, ` : ''
                    } ${place?.outcode}`
                    setPlaceName(pName)
                  }}
                  to={`/all/?lat=${place.latitude}&lon=${place.longitude}&storeType=${storeTypeDefault}`}
                >
                  {place?.name_1},{' '}
                  {place?.county_unitary ? `${place.county_unitary}, ` : null}
                  {place?.outcode}
                </Link>
              )
            })}
          </section>
        )
        break
      default:
        component = null
        break
    }
    return component
  }

  return (
    <>
      <div className="relative z-30 w-full lg:w-2/3 search">
        <div className="flex justify-between mb-4">
          <div
            className={`flex overflow-hidden flex-1 justify-between items-center px-2 pr-4 mr-2 bg-white rounded-lg shadow-2xl lg:mr-4 text-secondary }`}
          >
            <Icon
              icon={loading && !typing ? 'searchIconLoading' : 'searchIcon'}
              className="w-6 h-6 fill-current sm:w-8 sm:h-8 md:w-10 md:h-10"
            />

            <input
              name="q"
              defaultValue={inputText || filter?.postcode || filter?.place}
              autoComplete="off"
              data-cy="search-input"
              aria-label="search box"
              onKeyDown={handleKeyDown}
              onChange={e => {
                setInputText(e.target.value)
                setShowResults(true)
              }}
              placeholder="Enter postcode or location"
              className={`flex-auto py-3 ml-1 text-lg font-light truncate bg-transparent outline-none sm:text-2xl sm:py-6 text-body md:text-3xl placeholder-body caret-tertiary`}
            ></input>
            <label htmlFor="q" className="hidden" aria-hidden="true">
              Search Postcode or location
            </label>
            <button
              className={`flex items-center justify-center py-2 disabled:cursor-not-allowed rounded-lg group disabled:bg-opacity-80
            ${geoError &&
              'bg-body-lighter hover:bg-body-lighter bg-opacity-60 hover:bg-opacity-60 cursor-not-allowed'}`}
              onClick={() => {
                setPlaceName('')
                clickCurrentLocation()
                if (!!latitude && !!longitude) {
                  setQuery({
                    lon: longitude,
                    lat: latitude,
                    postcode: undefined,
                    place: undefined,
                  })
                } else {
                  getGeolocation()
                }
              }}
              disabled={fetchingPosition}
            >
              <Icon
                icon={fetchingPosition ? 'searchIconLoading' : 'location'}
                className={`w-8 h-8 py-1 fill-secondary group-hover:fill-body sm:w-9 sm:h-9 md:h-10 md:w-10  ${geoError &&
                  'group-hover:fill-body-light fill-body-light'}`}
              />
            </button>
          </div>
          <button
            className={`flex justify-center items-center px-4 py-1 rounded-lg text-body hover:text-white md:px-8 lg:px-12 group disabled:bg-opacity-80 bg-tertiary hover:bg-primary`}
            onClick={handleSearch}
          >
            <span className="text-base font-semibold whitespace-nowrap text-body sm:text-lg group-hover:text-white lg:text-xl">
              Search
            </span>
          </button>
        </div>
        {geoError && geoError.code === 1 && !inputText.length ? (
          <div className="p-4 text-white rounded-lg bg-body-dark">
            You have disabled geolocation for this website.
          </div>
        ) : null}

        {inputText.length > 2 && !loading && showResults ? (
          <>
            <div
              className="overflow-hidden absolute right-0 left-0 z-50 p-0 w-full text-left bg-white rounded-lg shadow-md"
              data-cy="search-container"
            >
              {renderSearchResults()}
            </div>
          </>
        ) : null}
        {inputText.length > 0 &&
        inputText.length < 3 &&
        !loading &&
        showResults ? (
          <div className="absolute right-0 left-0 z-10 px-6 w-full text-left text-white">
            Enter more characters...
          </div>
        ) : null}
      </div>
      <ModalOverlay
        isShowing={inputText.length > 2 && showResults && !loading}
        onClick={handleClose}
      />
    </>
  )
}

Search.propTypes = {
  mcColls: PropTypes.bool,
}

export default Search
